// Helper module to import all AmCharts libs at once
// use: import '@/modules/amcharts'

import(/* webpackChunkName: "l-amcharts" */ 'amcharts-3-single-website-license/amcharts/amcharts')
import(/* webpackChunkName: "l-amcharts" */ 'amcharts-3-single-website-license/amcharts/serial')
import(/* webpackChunkName: "l-amcharts" */ 'amcharts-3-single-website-license/amcharts/gantt')
import(/* webpackChunkName: "l-amcharts" */ 'amcharts-3-single-website-license/amcharts/plugins/export/export')
import(/* webpackChunkName: "l-amcharts" */ 'amcharts-3-single-website-license/amcharts/plugins/export/export.css')
import(/* webpackChunkName: "l-amcharts" */ 'amcharts-3-single-website-license/amcharts/images/dragIconRoundBig.svg')
import(/* webpackChunkName: "l-amcharts" */ 'amcharts-3-single-website-license/amcharts/images/lens.svg')
